const headerPackages = [
  'collectionsLead',
  'leadSectionFront',
  'magazineLead',
  'showLead',
  'slimLead',
  'waffle',
];

const headerLightPackages = [
  'bigHeadline',
  'bigStoryTakeover',
  'bigStoryTakeoverPlus2',
  'bigStoryTakeoverPlus3',
  'bigStoryTakeoverPlus4',
];

const headerTransparentPackages = [
  'leadSectionFront',
];

const verticalsWithHeaderLightPackages = [
  'msnbc',
  'news',
];

export const getFirstPackageFromPackages = (packages) => packages
  && packages.length
  && packages[0];

export const packageHasTitleOrType = (
  pck,
  packageType,
) => (pck.metadata && pck.metadata.title) || pck.type === packageType;

export const isLeadPackageAdjacent = (packageType) => ['collectionsLead'].includes(packageType);

export const makeStartingCountMapOfPackageTypes = (packages) => {
  const countMapOfPackageTypes = packages.reduce((accumulator, pkg) => {
    const { type } = pkg;
    accumulator[type] = 1;

    return accumulator;
  }, {});

  return countMapOfPackageTypes;
};

export const getNthPackageOfType = (packages, packageType, nthOccurring) => {
  const countMapOfPackageTypes = makeStartingCountMapOfPackageTypes(packages);

  const packagesByTypeOrder = packages.reduce((accumulator, pkg) => {
    const pkgKey = `${pkg.type}_${countMapOfPackageTypes[pkg.type]}`;

    accumulator[pkgKey] = { ...pkg };
    countMapOfPackageTypes[pkg.type] += 1;

    return accumulator;
  }, {});

  const computedKey = `${packageType}_${nthOccurring}`;
  const nthPackageOfType = packagesByTypeOrder[computedKey];

  return nthPackageOfType;
};

/**
 * Return first layout with packages.
 */
export const getFirstLayout = (
  layouts = [],
) => {
  if (Array.isArray(layouts)) {
    return layouts.find((l) => l.packages && l.packages.length) || { packages: [] };
  }
  return { packages: [] };
};

/**
 * Return first package of first populated layout.
 */
const getFirstPackage = (
  layouts,
) => getFirstPackageFromPackages(getFirstLayout(layouts).packages);

/**
 * Return type of first package of first populated layout.
 */
export const getFirstPackageType = (
  layouts,
) => (getFirstPackage(layouts) || {}).type;

/**
 * Test if layout contains any of the provided packages.
 */
const hasPackage = (
  layouts,
  packageTypes = [],
) => {
  const firstPackageType = getFirstPackageType(layouts);
  return packageTypes.includes(firstPackageType);
};

/**
 * Test if layout contains one of the flagged header packages.
 */
export const hasHeaderPackage = (layouts = []) => hasPackage(layouts, headerPackages);

/**
 * Test if layout contains one of the flagged transparent header packages.
 */
export const hasHeaderTransparentLightPackage = (
  layouts,
  vertical,
) => {
  if (!hasPackage(layouts, headerTransparentPackages)) {
    return false;
  }
  const firstPackage = getFirstPackage(layouts);
  const hasImage = firstPackage.metadata && firstPackage.metadata.imageUrl;
  return vertical === 'today' || (vertical === 'news' && hasImage);
};

/**
 * Test if layout contains one of the flagged light header packages.
 */
export const hasHeaderLightPackage = (
  layouts,
  vertical,
) => verticalsWithHeaderLightPackages.includes(vertical)
  && hasPackage(layouts, headerLightPackages);
